import { Link } from '@remix-run/react';

export default function Help() {
  return (
    <div>
      <h1 className="text-3xl font-bold">Help</h1>
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16 lg:py-20">
        <div className="space-y-8">
          <div>
            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Sync Your Data To Deliberate Time</h1>
            <p className="mt-4 text-lg text-gray-500 dark:text-gray-400">
              Learn how to get your data synced by installing our powerful Chrome extension.
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-bold tracking-tight">1. Download the extension</h2>
            <p className="mt-4 text-gray-500 dark:text-gray-400">
              Download the extension{' '}
              <Link to={downloadUrl} target="_blank" rel="noreferrer">
                here
              </Link>
              .
            </p>
            <ol className="mt-4 space-y-4 text-gray-500 dark:text-gray-400">
              <li>
                <a href="#" className="font-medium text-gray-900 dark:text-gray-50 hover:underline">
                  Download the ZIP file
                </a>
                containing the extension.
              </li>
              <li>Extract the contents of the ZIP file.</li>
              <li>
                Open the Chrome Extensions page (chrome://extensions/), enable Developer Mode, and drag-and-drop the extracted
                folder into the page to install the extension.
              </li>
            </ol>
          </div>
          <div>
            <h2 className="text-2xl font-bold tracking-tight">3. Google\'s Extension Installation Guide</h2>
            <p className="mt-4 text-gray-500 dark:text-gray-400">
              For more detailed instructions and troubleshooting, please refer to{' '}
              <a href="#" className="font-medium text-gray-900 dark:text-gray-50 hover:underline">
                Google\'s official guide on installing Chrome extensions
              </a>
              .
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-bold tracking-tight">4. Configuring the Extension</h2>
            <p className="mt-4 text-gray-500 dark:text-gray-400">
              After installing the extension, you\'ll need to configure it with your account settings. Here\'s how:
            </p>
            <ol className="mt-4 space-y-4 text-gray-500 dark:text-gray-400">
              <li>Open the extension\'s settings page by clicking on the extension icon in your Chrome toolbar.</li>
              <li>Locate the 'key' or 'API key' setting and copy the value from your account settings.</li>
              <li>Paste the copied key into the extension\'s settings to complete the configuration.</li>
            </ol>
          </div>
          <div>
            <h2 className="text-2xl font-bold tracking-tight">5. You\'re Done!</h2>
            <p className="mt-4 text-gray-500 dark:text-gray-400">
              Congratulations! You have successfully installed and configured the Chrome extension. If you have any further
              questions or need additional support, please don\'t hesitate to reach out to our customer service team.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const downloadUrl = 'https://deliberate-time-extension.s3.us-west-2.amazonaws.com/deliberate-time-latest.zip';
const extensionInstallGuideUrl = 'https://developer.chrome.com/docs/extensions/get-started/tutorial/hello-world#load-unpacked';
